export default {
	title: "Delete this goal?",
	description: "Deleting a goal cannot be undone. If you wish to retain a record of this goal, consider archiving it instead.",
	confirmButton: "Delete goal",
	dismissButton: "Do not delete",
};
